import React from 'react';

export type MarketingGlyphName = 'html5' | 'video' | 'mini-game';

export type MarketingGlyphProps = {
  name: MarketingGlyphName;
  size?: number;
  /** The stroke (and dot fill) paint: a colour or an SVG paint reference such as a gradient's `url(#…)`. */
  color?: string;
  className?: string;
};

/**
 * The Marketing hub's own tile glyphs, drawn like the shared `Icon`'s stroke set (24 viewBox, 1.6 stroke, round caps
 * and joins) so they sit beside its `image` glyph as one family: an HTML5 banner (a banner frame holding `</>`), a
 * video ad (a camera) and a mini-game (a gamepad).
 */
export const MarketingGlyph = ({
  name,
  size = 24,
  color = 'currentColor',
  className,
}: MarketingGlyphProps): React.ReactElement => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {name === 'html5' ? (
      <>
        <rect x="3" y="5" width="18" height="14" rx="2.5" />
        <path d="M9.5 9.5 7 12l2.5 2.5M14.5 9.5 17 12l-2.5 2.5M13 9l-2 6" />
      </>
    ) : name === 'video' ? (
      <>
        <rect x="2.75" y="6" width="13.5" height="12" rx="2.75" />
        <path d="M16.25 10.25 21 7.5v9l-4.75-2.75" />
      </>
    ) : (
      <>
        <path d="M7.5 7.5h9a4.5 4.5 0 0 1 4.5 4.5v.75a3.75 3.75 0 0 1-6.6 2.44l-.8-.94h-3.2l-.8.94A3.75 3.75 0 0 1 3 12.75V12a4.5 4.5 0 0 1 4.5-4.5Z" />
        <path d="M7.75 10.25v3M6.25 11.75h3" />
        <circle cx="15.75" cy="10.75" r="0.9" fill={color} stroke="none" />
        <circle cx="17.5" cy="12.75" r="0.9" fill={color} stroke="none" />
      </>
    )}
  </svg>
);

export default MarketingGlyph;
